import { createIcon } from './createIcon';

const svg = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M13 16.75V15.25C13 14.4544 12.6839 13.6913 12.1213 13.1287C11.5587 12.5661 10.7956 12.25 10 12.25H5.5C4.70435 12.25 3.94129 12.5661 3.37868 13.1287C2.81607 13.6913 2.5 14.4544 2.5 15.25V16.75"
      stroke="#09090B"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.75 9.25C9.40685 9.25 10.75 7.90685 10.75 6.25C10.75 4.59315 9.40685 3.25 7.75 3.25C6.09315 3.25 4.75 4.59315 4.75 6.25C4.75 7.90685 6.09315 9.25 7.75 9.25Z"
      stroke="#09090B"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17.5 16.7502V15.2502C17.4995 14.5855 17.2783 13.9397 16.871 13.4144C16.4638 12.889 15.8936 12.5138 15.25 12.3477"
      stroke="#09090B"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13 3.34766C13.6453 3.51288 14.2173 3.88818 14.6257 4.41439C15.0342 4.9406 15.2559 5.58778 15.2559 6.25391C15.2559 6.92003 15.0342 7.56722 14.6257 8.09342C14.2173 8.61963 13.6453 8.99493 13 9.16016"
      stroke="#09090B"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const TeamOutlinedIcon = createIcon(() => svg());

export default TeamOutlinedIcon;
